import urlcat from 'urlcat';

import { Routes } from 'src/constants/routes';

const getTaskSuggestedSchedulesUrl = (taskId: string) => {
  return urlcat(Routes.TaskSuggestedSchedules, { taskId });
};

export default getTaskSuggestedSchedulesUrl;
